import {getRouteApi} from "@tanstack/react-router";

export const clientContactsRouteApi = getRouteApi("/_app/sales/clients/$clientId/contacts/");
